
/*
  **************************************************************************
  public js
  **************************************************************************
*/

/**
 *
 * @type {{}}
 */
const common = {};

/**
 * main variable
 * @param data
 */
var mainVariable = {
    // todo
    contentStyle: null, // 内容区域 长宽
};

/**
 *
 * @returns {null}
 */
common.winContent = function () {
    mainVariable.contentStyle = {
        width: window.innerWidth,
        height: window.innerHeight - 104,
    };
    return mainVariable.contentStyle;
};

export default common;



// WEBPACK FOOTER //
// ./src/assets/js/public.js